import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/trade-network-search.svg'


const _withScopeId = n => (_pushScopeId("data-v-3216ad18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "project-log-sidenav" }
const _hoisted_2 = { class: "project-log-sidenav__side" }
const _hoisted_3 = { class: "project-log-sidenav__header" }
const _hoisted_4 = { class: "project-log-sidenav__title" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Logs", -1))
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Logs", -1))
const _hoisted_9 = { class: "audit__logs" }
const _hoisted_10 = { class: "confirm_date" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_13 = {
  key: 1,
  class: "audit__logs__content"
}
const _hoisted_14 = { class: "overview__detail" }
const _hoisted_15 = { class: "overview__detail__date" }
const _hoisted_16 = { class: "overview__detail__group" }
const _hoisted_17 = { class: "overview__detail__project__name" }
const _hoisted_18 = { class: "overview__detail__item__wrapper" }
const _hoisted_19 = { class: "overview__detail__item__list" }
const _hoisted_20 = { class: "overview__detail__icon" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "overview__detail__content" }
const _hoisted_23 = { class: "overview__detail__text" }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = { class: "overview__detail__time" }
const _hoisted_26 = {
  key: 2,
  class: "no-logs-message"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No logs available", -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "project-log-sidenav__overlay tw-hidden" }, null, -1))

import { computed, onMounted, watch, ref } from "vue";
import moment from "moment";
import { debounce } from "lodash";
import { DatePicker } from "v-calendar";
import * as XLSX from "xlsx";
import store from "@/store";
import { AUDIT_LOG_STORE } from "@/store/modules/audit-logs";
import { JOBS_STORE } from "@/store/modules/jobs";
import { PROJECT_STORE } from "@/store/modules/project";
import { UserRolesEnum } from "../enums/RolesEnum";
import { USER_STORE } from "@/store/modules/user";
import CommonLoader from "./CommonLoader.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AuditLogComponent',
  emits: ["closeModal"],
  setup(__props, { emit: __emit }) {

const searchQuery = ref("");
const emits = __emit;
const dataRange = ref();
const projectId = ref();
const projectName = ref();
const loading = ref(false);

const user = computed(() => store.getters[`${USER_STORE}/user`]);
const currentJobDetails = computed(
  () => store.getters[`${JOBS_STORE}/getJobDetails`]
);
const projectJobdetails = computed(
  () => store.getters[`${PROJECT_STORE}/projectDetails`]
);
const auditLogs_all = computed(
  () => store.getters[`${AUDIT_LOG_STORE}/getAuditLogsList_all`]
);

const groupedAuditLogs: any = computed(() => {
  return auditLogs_all.value.reduce((groups: any, log: any) => {
    const date = log?.dateCreated?.split("T")[0]; // Extract date
    const projectId = log?.project?.id; // Extract project ID

    if (!groups[date]) {
      groups[date] = {}; // Initialize date group
    }

    if (!groups[date][projectId]) {
      groups[date][projectId] = []; // Initialize project group
    }

    groups[date][projectId].push(log); // Add log to the project group
    return groups;
  }, {});
});

const closeAuditModal = () => {
  emits("closeModal");
};

const formatDateWithMoment = (date: any) => moment(date).format("DD-MM-YYYY");
const formatDateWithTime = (date: any) => moment(date).format("hh:mm a");

const searchApi = async (
  query: any,
  startDate: any = "",
  endDate: any = ""
) => {
  let queryParams = query?.trim();
  loading.value = true;
  await store.dispatch(`${AUDIT_LOG_STORE}/getAuditLogs_all`, {
    search: queryParams,
    startDate,
    endDate,
    projectId: projectId?.value?.toString(),
  });
  loading.value = false;
};

const downloadAuditLogs = () => {
  const wb = XLSX.utils.book_new();
  const ws_name = "Audit Logs";
  const ws_data = [["Date", "Content", "Time"]];

  if (auditLogs_all.value && typeof auditLogs_all.value === "object") {
    Object.entries(auditLogs_all.value).forEach(([date, group]) => {
      const logs = Array.isArray(group) ? group : [group];
      logs.forEach((log) => {
        if (log && typeof log === "object") {
          const content = log.content || "No content";
          const time = formatDateWithTime(log.dateCreated) || "No time";
          const formattedDate = formatDateWithMoment(log.dateCreated) || date;
          ws_data.push([formattedDate, content, time]);
        }
      });
    });
  } else {
    console.error("Invalid auditLogs_all.value structure or missing data");
  }

  const ws = XLSX.utils.aoa_to_sheet(ws_data);
  XLSX.utils.book_append_sheet(wb, ws, ws_name);
  XLSX.writeFile(wb, "Audit-log.xlsx");
};

const getRandomIcon = () => {
  const icons = ["pad-pen.svg", "calu-pen.svg", "pen-filled-yellow-icon.svg"];
  return icons[Math.floor(Math.random() * icons.length)];
};

const debouncedSearch = debounce(() => {
  searchApi(searchQuery.value);
}, 1000);

watch(dataRange, (newValue, oldValue) => {
  if (newValue && newValue.start && newValue.end) {
    filterAuditLogsByDate(newValue.start, newValue.end);
  }
});

const filterAuditLogsByDate = (startDate: any, endDate: any) => {
  searchApi(
    searchQuery.value,
    moment(startDate).format("YYYY-MM-DD"),
    moment(endDate).format("YYYY-MM-DD")
  );
};

onMounted(async () => {
  if (user.value.role.name === UserRolesEnum.PROPERTY_OWNER) {
    projectId.value = projectJobdetails?.value?.id;
    projectName.value = projectJobdetails?.value?.name || "Unknown Project";
  } else {
    projectId.value = currentJobDetails?.value?.id;
    projectName.value = currentJobDetails?.value?.name || "Unknown Project";
  }

  loading.value = true;

  await store.dispatch(`${AUDIT_LOG_STORE}/getAuditLogs_all`, {
    search: "",
    starDate: "",
    endDate: "",
    projectId: projectId.value?.toString(),
  });

  loading.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (projectId.value)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_5, [
                _createTextVNode(_toDisplayString(projectName.value) + " ", 1),
                _hoisted_6
              ]))
            : _createCommentVNode("", true),
          (!projectId.value)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_7, [
                _createTextVNode("Global "),
                _hoisted_8
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_v_icon, {
            icon: "mdi-close",
            class: "tw-cursor-pointer",
            onClick: closeAuditModal
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_unref(DatePicker), {
              modelValue: dataRange.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dataRange).value = $event)),
              modelModifiers: { range: true },
              class: "date__selector",
              popover: true
            }, {
              default: _withCtx(({ togglePopover, inputValue, inputEvents }) => [
                _createElementVNode("div", {
                  class: "calendar__select",
                  onClick: () => togglePopover()
                }, [
                  _createVNode(_component_v_text_field, _mergeProps({
                    value: 
                      inputValue.start
                        ? `${inputValue.start}
            ${inputValue.end}`
                        : ''
                    
                  }, _toHandlers(inputEvents), {
                    variant: "outlined",
                    placeholder: "Choose Date",
                    class: "date__start c-input",
                    "prepend-icon": "mdi-calendar-text",
                    color: "#0C0F4A"
                  }), null, 16, ["value"])
                ], 8, _hoisted_11)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_v_btn, {
              "prepend-icon": "mdi-tray-arrow-down",
              class: "button button-lightGray",
              size: "large",
              onClick: downloadAuditLogs
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Download XLS ")
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_v_text_field, {
            placeholder: "Search",
            class: "search_field",
            "bg-color": "#fff",
            variant: "outlined",
            modelValue: searchQuery.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchQuery).value = $event)),
            onInput: _unref(debouncedSearch)
          }, {
            "prepend-inner": _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }, 8, ["modelValue", "onInput"]),
          (loading.value)
            ? (_openBlock(), _createBlock(CommonLoader, {
                key: 0,
                loading: loading.value,
                class: "loader-container"
              }, null, 8, ["loading"]))
            : _createCommentVNode("", true),
          (Object.keys(groupedAuditLogs.value).length && !loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedAuditLogs.value, (projects, date) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: date,
                    class: "overview__detail__wrapper"
                  }, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("h6", null, _toDisplayString(formatDateWithMoment(date)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projects, (logs, projectId) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: projectId,
                            class: "overview__detail__project"
                          }, [
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("h6", null, [
                                _createTextVNode(_toDisplayString(logs[0]?.project?.name || "Unknown Project") + " ", 1),
                                _createElementVNode("span", null, _toDisplayString(logs?.[0]?.logsGroupType), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logs, (log) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: log.id,
                                  class: "overview__detail__item"
                                }, [
                                  _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("div", _hoisted_20, [
                                      _createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => [
                                          _createElementVNode("img", {
                                            src: 
                                  require('@/assets/icons/' + getRandomIcon())
                                ,
                                            alt: ""
                                          }, null, 8, _hoisted_21)
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("div", _hoisted_23, [
                                      _createElementVNode("p", {
                                        innerHTML: log.content
                                      }, null, 8, _hoisted_24)
                                    ]),
                                    _createElementVNode("div", _hoisted_25, [
                                      _createElementVNode("p", null, _toDisplayString(formatDateWithTime(log.dateCreated)), 1)
                                    ])
                                  ])
                                ]))
                              }), 128))
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                }), 128))
              ]))
            : (!loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
              : _createCommentVNode("", true)
        ])
      ])
    ]),
    _hoisted_29
  ]))
}
}

})